import MButton from '@assets/mui/@material-extend/MButton';
import palette from '@assets/theme/palette';
import PlusIcon from '@components/icons/Plus';
import TimeIcon from '@components/icons/Time';
import { BreadCrumbProps } from '@components/UI/breadcrumbs';
import CardWrapper from '@components/UI/CardWrapper';
import useMyRouting from '@context/useMyRouting/useMyRouting';
import { useYaHit } from '@context/useYaHit';
import { useMediaQuery } from '@material-ui/core';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useDelivery from '@pages/AdditionalServices/tabs/DeliveryForm/useDelivery';
import { EmptyBasketPlaceholder } from '@pages/Basket/EmptyBasketPlaceholder';
import { CALUCLATOR_LINK_BY_LANG_ID } from '@settings/localization/consts';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SwipeableThanksDrawerStyledContainer } from './StyledComponents';

const TYOrder = () => {
  const { t } = useTranslation(['TYOrder', 'CartComponent', 'PageNames', 'Common']);
  const textTy = t('TYOrder:ThankYou');
  const textContact = (
    <>
      {t('TYOrder:OurManagerWillContactYou')}
      <br />
      {t('TYOrder:ArchivesNote.Part1')}{' '}
      <Link href={t('Common:ArchivesLink')} underline="hover">
        {t('TYOrder:ArchivesNote.ArchivesLink')}
      </Link>
      {t('TYOrder:ArchivesNote.Part2')}
    </>
  );
  const { setPage } = useMyRouting().actions;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { useAggregationData } = useDelivery();
  const [aggregationData] = useAggregationData().useState();
  const [settings] = useDelivery().useSettings().useState();

  const { primaryLanguageId } = settings;

  const link = CALUCLATOR_LINK_BY_LANG_ID[primaryLanguageId] || CALUCLATOR_LINK_BY_LANG_ID.default;

  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(true);

  useYaHit({});

  const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

  const breadCrumbs: BreadCrumbProps[] = [
    {
      id: 1,
      name: t('PageNames:MainPage'),
      url: 'widget',
    },
    {
      id: 2,
      name: t('PageNames:MyOrder'),
      url: 'basket',
    },
    {
      id: 3,
      name: t('PageNames:OrderProcessed'),
    },
  ];

  const goToCalculator = () => {
    window.open(link, '_self');
    setPage('widget');
  };

  const goToApplications = () => {
    window.open('/personal/requests/?requestsTab=unconfirmed', '_self');
  };

  const closeDrawerHandler = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      {!isMobile && (
        <EmptyBasketPlaceholder
          breadCrumbs={breadCrumbs}
          titleText={t('TYOrder:Title')}
          subTitleText={t('TYOrder:ThankYou')}
          infoText={textContact}
          calculatorBtnText={t('CartComponent:SelectedServiceButton')}
          goToApplicationsBtnText={t('TYOrder:GoToApplications')}
        />
      )}

      {isMobile && (
        <>
          <EmptyBasketPlaceholder
            breadCrumbs={breadCrumbs}
            titleText={t('TYOrder:Title')}
            subTitleText={t('TYOrder:ThankYou')}
            infoText={textContact}
            calculatorBtnText={t('CartComponent:SelectedServiceButton')}
            goToApplicationsBtnText={t('TYOrder:GoToApplications')}
          />
          <SwipeableThanksDrawerStyledContainer
            anchor="bottom"
            SwipeAreaProps={{
              disablePortal: true,
            }}
            open={isDrawerOpen}
            onClose={closeDrawerHandler}
            onOpen={() => {}}
            disableBackdropTransition={!iOS}
            disableDiscovery={iOS}
            swipeAreaWidth={aggregationData ? 70 : undefined}
          >
            <CardWrapper className={'card-wrapper'}>
              <div className="drawer-control">
                <IconButton color="primary" className="close-drawer" onClick={closeDrawerHandler}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="7"
                    viewBox="0 0 17 7"
                    fill="none"
                    stroke="none"
                  >
                    <path d="M16 6L8.5 0.642856L1 6" stroke="black" fill="none" />
                  </svg>
                </IconButton>
              </div>
              <Typography variant={'h2'} color={'common.black'} className={'section-title'}>
                {textTy}
              </Typography>
              <Typography variant={'body1'} color={'common.black'} className={'section-info'}>
                {textContact}
              </Typography>
              <div className="action-wrapper">
                <MButton
                  className={'calculation-link applications'}
                  onClick={goToApplications}
                  fullWidth={true}
                  variant={'contained'}
                  startIcon={<TimeIcon />}
                  size={'large'}
                  color={'primary'}
                  sx={{
                    color: palette.light.text,
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                >
                  <span>{t('TYOrder:GoToApplications')}</span>
                </MButton>
                <MButton
                  className={'calculation-link'}
                  onClick={goToCalculator}
                  fullWidth={true}
                  variant={'outlined'}
                  startIcon={<PlusIcon />}
                  size={'large'}
                  color={'inherit'}
                  sx={{
                    color: palette.light.blue[400],
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                >
                  <span>{t('CartComponent:SelectedServiceButton')}</span>
                </MButton>
              </div>
            </CardWrapper>
          </SwipeableThanksDrawerStyledContainer>
        </>
      )}
    </>
  );
};

export default TYOrder;
